{
  "title": "Атаки",
  "table": {
    "sid": "SID",
    "gid": "GID",
    "sensor_id": "dev ID",
    "time": "Время",
    "priority": "Приоритет",
    "proto": "Proto",
    "attacker_ip": "IP src",
    "attacker_port": "Порт src",
    "host_ip": "IP dst",
    "host_port": "Порт dst",
    "payload": "Payload"
  },
  "filter": {
    "datetime": "Дата и время",
    "attacker_ip": "Входящий IP",
    "host_ip": "Исходящий IP",
    "priority": "Приоритет"
  }
}